import { styled, Tab, TabsNavigation, alpha } from '@ltvco/refresh-lib/theme';
import { createElement, type ComponentProps } from 'react';

const LegalResearchTabsNavigationBase = (
  props: ComponentProps<typeof TabsNavigation>
) => createElement(TabsNavigation, { ...props, scrollButtons: false });

export const LegalResearchTabsNavigation = styled(
  LegalResearchTabsNavigationBase
)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  position: 'relative',
  borderBottom: `1px solid ${theme.palette.divider}`,
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    gap: 0,
    alignItems: 'flex-end',
  },
  '& .MuiTab-root': {
    position: 'relative',
    zIndex: 1,
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: 78,
    '& .MuiTabs-scroller': {
      overflow: 'visible',
    },
    '& .MuiTabs-flexContainer': {
      width: '100%',
    },
  },
}));

export const LegalResearchTab = styled(Tab)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  alignSelf: 'stretch',
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body2.fontSize,
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightMedium || 500,
  lineHeight: theme.typography.body2.lineHeight,
  letterSpacing: '0.4px',
  textTransform: 'capitalize',
  minHeight: 48,
  padding: theme.spacing(1.5, 2),
  minWidth: 'auto',
  color: theme.palette.text.secondary,
  borderBottom: '3px solid transparent',
  '& .MuiTab-iconWrapper': {
    marginRight: 0,
  },
  '& .MuiSvgIcon-root': {
    fontSize: '20px',
  },
  '&:hover:not(.Mui-selected)': {
    color: theme.palette.text.primary,
    backgroundColor: alpha(theme.palette.text.primary, 0.06),
    borderTopLeftRadius: theme.spacing(1),
    borderTopRightRadius: theme.spacing(1),
  },
  '&.Mui-selected': {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    borderTopLeftRadius: theme.spacing(1),
    borderTopRightRadius: theme.spacing(1),
    borderBottom: `3px solid ${theme.palette.primary.main}`,
    marginBottom: '-1px',
    zIndex: 2,
  },
  [theme.breakpoints.down('sm')]: {
    flex: 1,
    fontSize: '13px',
    lineHeight: '18px',
    minHeight: 78,
    padding: theme.spacing(1.25, 0.5),
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(0.5),
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    '&:hover:not(.Mui-selected)': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
    '&.Mui-selected': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
    '& .MuiTab-iconWrapper': {
      marginBottom: 0,
    },
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
    },
  },
}));
